import React, { useEffect, useState } from 'react';

import {
    Box,
    Typography,
    Button,
    Dialog,
    IconButton,
    Container,
    LinearProgress,
    AppBar,
    Toolbar,
    Grid,
    Paper,
    styled,
    Card,
    ImageList,
    ImageListItem,
    ImageListItemBar,
    ListSubheader,
    ListItem,
    List,
    TextField,
    ListItemText,
    Link
} from '@mui/material';

import * as yup from "yup";
import { useFormik } from 'formik';

import { useDropzone } from 'react-dropzone'

import { grey } from '@mui/material/colors';

import CommonSectionHeader from "../../../../../../components/common/CommonSectionHeader"

import { useSystemPrompt } from "../../../../../../hooks/useSystemPrompt"
import { useTranslations } from "../../../../../../hooks/useTranslations";

import { useAppContextFeatures } from '../../../../../../context/AppContext';


import { useAuthAccess } from "../../../../../../hooks/useAuthAccess"

import {
    productImageTypes
} from "../../../../hooks/model/useProduct"

import {
    useProductImage
} from '../../../../hooks/model/useProductImage';

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2)
}));


const RenderFormSavedItem = (props) => {

    const { t } = useTranslations({ ns: ["_@products", "common", "_common"] })

    const {
        id,
        // parentId,
        index,
        data: file,
        handleSave,
        handleDelete
    } = props

    let preview = file?.file_url;// URL.createObjectURL(file)
    const desc = file?.description ? file.description : ""

    const validationSchema = yup.object({
        description: yup
            .string()
            .required("Required"),
    })

    const initialValues = {
        description: desc,
        id,
        // parentId
    }

    const onSubmit = async (currentValues) => {
        await handleSave(currentValues)
    }

    const handleDeleteItem = async (currentValues) => {
        await handleDelete(currentValues)
    }

    const formik = useFormik({
        initialValues,
        validationSchema,
        enableReinitialize: true,
        onSubmit
    });

    const { values, errors, touched, handleChange, handleSubmit, setFieldValue } = formik;

    // The API already returns the final CDN URL (assets-public.sdgroup.com.my) for every hub.

    return (
        <form onSubmit={handleSubmit}>
            <ListItem
                key={index}
                divider
                disablePadding
                disableGutters
                sx={{
                    py: 2,
                }}
            >
                {/* {JSON.stringify(file)} */}
                {/* {JSON.stringify(values)} */}
                {/* {JSON.stringify(errors)} */}
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={4}>
                        <Box
                            sx={{
                                maxHeight: 200,
                                width: '100%',
                                overflow: 'hidden',
                                borderColor: grey[400],
                                borderWidth: 1,
                                borderStyle: 'solid',
                                borderRadius: 2
                            }}
                        >
                            <Link
                                href={`${preview}`}
                                target='_blank'
                                variant="body2"
                            >
                                <img
                                    srcSet={`${preview}`}
                                    src={`${preview}`}
                                    alt={`Preview #${index}`}
                                    loading="lazy"
                                />
                            </Link>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={12} md={8}>
                        <TextField
                            margin="dense"
                            size="small"
                            // autoFocus
                            // disabled
                            fullWidth
                            name={"description"}
                            label={t('description')}
                            type="text"
                            rows={4}
                            multiline
                            variant="outlined"
                            value={values?.description ? values.description : ""}
                            onChange={(event) => {
                                setFieldValue(`description`, event.target.value)
                            }}
                            error={touched.description && Boolean(errors.description)}
                            helperText={touched.description && errors.description}
                        />
                        <Grid item md={12} display={"flex"} justifyContent={"flex-end"} alignItems={"center"}>
                            <Button
                                variant='contained'
                                type='submit'
                                fullWidth
                            >
                                {t("saveChanges")}
                            </Button>
                            <Button
                                variant='contained'
                                type='button'
                                color={"error"}
                                sx={{ ml: 1 }}
                                onClick={() => {
                                    handleDeleteItem(values)
                                }}
                            >
                                {t('delete')}
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </ListItem>
        </form>
    )
}

export default function UpdateProductImages({
    routeType,
    id,
    handleOnSuccess
    // handleOnCancel,
    // handleOnSelect,
    // textProps
}) {

    const { t } = useTranslations({ ns: ["_@products", "_prompt", "common", "_common"] })

    const { promptMessage } = useSystemPrompt()

    const { authData } = useAuthAccess(routeType)

    const {
        isUploading,
        uploadState,
        listProductImages,
        updateProductImage,
        addProductImages,
        deleteProductImages,
        // filterOperatorTypes
    } = useProductImage({ routeType })

    const { setSystemLoading } = useAppContextFeatures()
    // const { isPermissionAllow } = usePermissions(routeType, scopeIds.product.id, scopeTypes.product.item.id)

    const [dataSaved, setDataSaved] = useState([])

    // const initialFile = {
    //     mainState: "initial", // initial
    //     imageUploaded: 0,
    //     selectedFile: "",
    //     source: {}
    // }

    const [inputFiles, setInputFiles] = useState([])

    const {
        acceptedFiles,
        fileRejections,
        getRootProps,
        getInputProps,
    } = useDropzone({
        accept: {
            'image/jpeg': [],
            'image/png': []
        }
    });

    // console.log('authData', authData)

    const authDataUserId = `${authData?.profile?.user?.id}`
    const authDataUserDisplay = `${authData?.profile?.user?.username}`

    const loadData = async (id) => {

        setSystemLoading(true);

        try {

            // const { data } = await get({ id, itemType: itemTypes.product })

            // let filterValues = [];

            // filterValues.push({
            //     name: "module",
            //     operator: filterOperatorTypes.eq,
            //     value: fileModuleTypes.item.product.value,
            // })

            // filterValues.push({
            //     name: "file_ref",
            //     operator: filterOperatorTypes.eq,
            //     value: fileReferenceTypes.item.product.value,
            // })

            // filterValues.push({
            //     name: "type",
            //     operator: filterOperatorTypes.eq,
            //     value: productImageTypes.galleryImages.typeValue,
            // })

            // filterValues.push({
            //     name: "tag",
            //     operator: filterOperatorTypes.eq,
            //     value: productImageTypes.galleryImages.tagValue,
            // })

            // filterValues.push({
            //     name: "refer_id",
            //     operator: filterOperatorTypes.eq,
            //     value: id,
            // })

            const props = {
                limit: -1,
                offset: 0,
                filterValue: [],
                sortInfo: {
                    id: "id",
                    dir: 0,
                }
            }

            // const { data } = await listFiles(props)
            const { data } = await listProductImages({
                props,
                productId: id,
                imageType: productImageTypes.galleryImages.typeValue,
                imageTag: productImageTypes.galleryImages.tagValue
            })

            // console.log('data', data)

            // setDataSaved(
            //     data?.files ? data.files : []
            // )

            setDataSaved(data)

        } catch (error) {
            promptMessage(false, `${error?.message}`)
        }

        setSystemLoading(false)

    }

    const handleSave = async (currentValues) => {

        setSystemLoading(true)

        try {

            const response = await updateProductImage({
                productId: id,
                lastUpdateUserId: `${authDataUserId}`,
                lastUpdateUserDisplay: `${authDataUserDisplay}`,
                imageId: currentValues?.id,
                description: currentValues?.description
            })

            // const data = {
            //     file: {
            //         description: currentValues?.description
            //     }
            // }

            // const response = await update({ id: currentValues?.id, data });

            promptMessage(true, `${response?.message}`)
            // navigate(getRoute("products"))

            // if(onSuccessSave) onSuccessSave()

            loadData(id)

        } catch (error) {
            promptMessage(false, `Action Failed (${error?.message})`)
        }

        setSystemLoading(false)

    }

    const handleDelete = async (currentValues) => {

        setSystemLoading(true)

        try {

            const ids = [currentValues?.id]

            // const response = await removeFiles({ ids, actionType: actionTypes.item.image });
            const response = await deleteProductImages({
                ids,
                productId: id,
                lastUpdateUserId: `${authDataUserId}`,
                lastUpdateUserDisplay: `${authDataUserDisplay}`,
            });

            promptMessage(true, `${response?.message}`)

            loadData(id)

            // if(onSuccessDelete) onSuccessDelete()

        } catch (error) {
            promptMessage(false, `Action Failed (${error?.message})`)
        }

        setSystemLoading(false)

    }

    useEffect(() => {

        loadData(id)

    }, [])

    useEffect(() => {

        handleSelectFiles()

    }, [acceptedFiles])

    const readFileAsDataUrl = (file) => {
        return new Promise((resolve, reject) => {
            let fr = new FileReader();

            fr.onload = function () {
                resolve(fr.result);
            };

            fr.onerror = function () {
                reject(fr);
            };

            fr.readAsDataURL(file);
        });
    }

    const handleSelectFiles = async () => {

        if (acceptedFiles && acceptedFiles.length <= 0) return false;

        // console.log('acceptedFiles', acceptedFiles)

        try {

            let readers = [];

            acceptedFiles.forEach(file => {
                readers.push(readFileAsDataUrl(file));
            })

            let a = await Promise.all(readers);

            // console.log('a', a)

            let payloadFiles = acceptedFiles.map((file, index) => {

                return {
                    base64: a[index],
                    source: {
                        fileName: file?.name
                    }
                }
            })

            setInputFiles(payloadFiles)

            // let dataFile = {
            //     file: {
            //         base64_attachments: [
            //             {
            //                 ...initialFileValues,
            //                 module: fileModuleTypes.item.product.value, /* required */
            //                 file_ref: fileReferenceTypes.item.product.value, /* required */
            //                 type: productImageTypes.nfcImage.typeValue, /* required */
            //                 tag: productImageTypes.nfcImage.tagValue,
            //                 name: `${newFileName}`, /* required */
            //                 description: `Identity No. : ${currentValues?.identityNo} / Name : ${currentValues?.name}`,
            //                 refer_id: id, /* required */
            //                 base64_code: base64
            //             }
            //         ]
            //     }
            // }

            // let response = await createFiles({ data: dataFile })

            // promptMessage(true, `${response?.message}`)

            // loadData(id)

        } catch (error) {
            promptMessage(false, `${error.message}`)
            return false
        }

        return true

    };

    const handleConfirmUpload = async () => {

        setSystemLoading(true)

        try {

            let payload = {
                productId: id,
                inputFiles,
                imageType: productImageTypes.galleryImages.typeValue,
                imageTag: productImageTypes.galleryImages.tagValue
            }

            payload = {
                ...payload,
                productId: id,
                lastUpdateUserId: `${authDataUserId}`,
                lastUpdateUserDisplay: `${authDataUserDisplay}`,
            }

            let response = await addProductImages(payload)

            // let newFileId = ''

            // if (inputFile?.selectedFile) {

            // let dataFiles = []

            // inputFiles.forEach((i, index) => {

            //     let fileName = i?.source?.fileName
            //     let base64 = i?.base64

            //     let fileExtension = fileName.split('.').pop();
            //     let newFileName = `${id}.${fileExtension}` // use product id as file name

            //     // base64 = base64.toString().replace('data:image/png;base64,', '')

            //     base64 = base64.toString().split(',').pop();

            //     // console.log('base64', base64)

            //     dataFiles.push({
            //         ...initialFileValues,
            //         module: fileModuleTypes.item.product.value, /* required */
            //         file_ref: fileReferenceTypes.item.product.value, /* required */
            //         type: productImageTypes.galleryImages.typeValue, /* required */
            //         tag: productImageTypes.galleryImages.tagValue,
            //         name: `${newFileName}`, /* required */
            //         description: `${t('galleryImage')} #${(index + 1)}`,
            //         refer_id: id, /* required */
            //         base64_code: base64
            //     })

            // })

            // let dataFile = {
            //     file: {
            //         base64_attachments: dataFiles
            //     }
            // }

            // let response = await createFiles({ data: dataFile })

            // console.log('response', response)

            setSystemLoading(false)

            promptMessage(true, `${response?.message}`)

            // if (handleOnSuccess) handleOnSuccess()

            setInputFiles([])

            loadData(id)

        } catch (error) {
            promptMessage(false, `Action Failed. (${error?.message})`)
        }

        setSystemLoading(false)

    }

    const RenderLinearProgress = () => {

        if (isUploading === false) return <></>

        // console.log('uploadState', uploadState)

        return (
            <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                <Box sx={{ width: '100%', mr: 1 }}>
                    <LinearProgress variant="determinate" value={uploadState?.percent ? parseFloat(uploadState.percent) : 0} />
                </Box>
                <Box sx={{ minWidth: 35 }}>
                    <Typography variant="body2" color="text.secondary">
                        {`${Math.round(uploadState?.percent,)}%`}
                    </Typography>
                </Box>
            </Box>
        );
    }

    const RenderPreview = () => {
        return (
            <Box
                textAlign={"left"}
            >
                <Box
                    display={"flex"}
                    justifyContent={"space-between"}
                    alignItems={"center"}
                >
                    <Typography
                        textAlign={"left"}
                    >
                        {t('previewImage')}
                    </Typography>
                    <Button
                        variant="text"
                        color='primary'
                        onClick={() => {
                            setInputFiles([])
                        }}
                    >
                        {t('clearAll')}
                    </Button>
                </Box>
                <ImageList sx={{ mt: 1 }} cols={10} rowHeight={100}>

                    {
                        inputFiles.map((file, index) => {

                            // const preview = URL.createObjectURL(file)
                            const base64 = file?.base64

                            return (

                                <ImageListItem
                                    key={index}
                                    sx={{
                                        // borderWidth: 1,
                                        // borderColor: '#e1e1e1',
                                        // borderStyle: 'solid',
                                        // borderRadius: 2,
                                        p: 0,
                                        m: 1
                                    }}
                                >
                                    <img
                                        // srcSet={`${preview}`}
                                        src={`${base64}`}
                                        alt={`Preview #${index}`}
                                    // loading="lazy"
                                    />
                                </ImageListItem>
                            )

                        })
                    }
                </ImageList>

                <Button
                    fullWidth
                    variant='contained'
                    onClick={handleConfirmUpload}
                    sx={{
                        mt: 1
                    }}
                >
                    {t('confirmUpload')}
                </Button>
            </Box>
        )
    }

    const RenderFormUpload = () => {
        return (
            <Box
                sx={{
                    // border: '3px dashed #eeeeee',
                    borderWidth: 1,
                    borderStyle: 'dotted',
                    borderColor: "primary", // grey[400],
                    backgroundColor: grey[100],
                    borderRadius: 2,
                    // p: 6,
                    py: 3,
                    px: 3,
                    // minHeight: 300,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}

            >
                <RenderLinearProgress />

                {
                    inputFiles.length <= 0 ?
                        (
                            <Box
                                {...getRootProps({ className: 'dropzone' })}
                                textAlign={"center"}
                                sx={{
                                    // p: 2
                                }}
                            >
                                <Button
                                    variant='outlined'
                                    color="primary"
                                >
                                    <input {...getInputProps()} />
                                    {/* <Typography
                                sx={{
                                    color: 'secondary.main'
                                }}
                            > */}
                                    {t('dropImagesHereOrClickToSelectFilesForUpload')}
                                    {/* </Typography> */}
                                </Button>
                            </Box>
                        )
                        :
                        (
                            <RenderPreview />
                        )
                }



            </Box>
        )
    }

    const RenderFormSaved = () => {

        if (dataSaved.length <= 0) {
            return (
                <ListItemText
                    primary={t('noImagesSaved')}
                    sx={{
                        textAlign: 'center'
                    }}
                />
            )
        }

        return (
            <List
                disablePadding
            >
                {
                    dataSaved.map((file, index) => {

                        return (
                            // RenderFormSavedItem({
                            //     key: index,
                            //     index,
                            //     data: file
                            // })

                            <RenderFormSavedItem
                                id={file?.id}
                                // parentId={id}
                                key={index}
                                index={index}
                                data={file}
                                handleSave={handleSave}
                                handleDelete={handleDelete}
                            />

                        )
                    })
                }
            </List>
        )
    }

    const RenderForm = () => {
        return (
            <StyledCard>
                {/* {JSON.stringify(fileRejections)} */}
                {/* {JSON.stringify(acceptedFiles)} */}
                {/* {id} */}
                <Grid container spacing={2}>
                    <Grid item md={12}>
                        {
                            RenderFormUpload()
                        }
                    </Grid>
                    <Grid item md={12}>
                        <CommonSectionHeader
                            title={t('savedImages')}
                            subTitle={t('describedTheImageInformation')}
                        />
                        {
                            RenderFormSaved()
                        }
                    </Grid>
                </Grid>

                {/* <ImageList sx={{ mt: 1 }} cols={4} rowHeight={200}>
                    {
                        acceptedFiles.map((file, index) => {

                            const preview = URL.createObjectURL(file)

                            return (
                                
                                <ImageListItem 
                                    key={index}
                                    sx={{
                                        borderWidth: 1,
                                        borderColor: '#e1e1e1',
                                        borderStyle: 'solid',
                                        borderRadius: 2,
                                        p: 1
                                    }}
                                >
                                    <img
                                        srcSet={`${preview}`}
                                        src={`${preview}`}
                                        alt={`Preview #${index}`}
                                        loading="lazy"
                                    />
                                    <ImageListItemBar
                                        title={file.path}
                                        subtitle={file.size}
                                        // actionIcon={
                                        // <IconButton
                                        //     sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
                                        //     aria-label={`info about ${item.title}`}
                                        // >
                                        //     <InfoIcon />
                                        // </IconButton>
                                        // }
                                    />
                                </ImageListItem>
                                // <Grid item md={3}>
                                //     <Paper variant="outlined" sx={{ p: 1, maxHeight: 200 }}>
                                //         <img
                                //             src={preview}
                                            
                                //             // style={{
                                //             //     width: 300,
                                //             //     height: 300
                                //             // }}
                                //             // Revoke data uri after image is loaded
                                //             onLoad={() => { URL.revokeObjectURL(preview) }}
                                //             alt={`Preview #${index}`}
                                //             sx={{
                                //                 objectF
                                //             }}
                                //         />
                                //         <Typography
                                //             sx={{
                                //                 fontSize: 12
                                //             }}
                                //         >
                                //             {file.path}
                                //         </Typography>
                                //     </Paper>
                                // </Grid>
                            )

                        })
                    }
                </ImageList> */}

                {/* <aside>
                        <h4>Files</h4>
                        <ul>{selectedFiles}</ul>
                    </aside> */}

                {/* <Stack direction="row" alignItems="center" spacing={2}>
                    <label htmlFor="upload-image">
                    <Button variant="contained" component="span">
                        Upload
                    </Button>
                    <input
                        id="upload-image"
                        hidden
                        accept="image/*"
                        type="file"
                        onChange={handleSelectFiles}
                    />
                    </label>
                    {imageUrl && <img src={imageUrl} alt="Uploaded Image" height="300" />}
                </Stack> */}
            </StyledCard>
        )
    }

    return (
        <Box>

            {
                RenderForm()
            }

            {/* {
                isPermissionAllow({ functionType: functionTypes.pageImages.ids }) ?
                    RenderForm()
                    :
                    <CommonRestricted />
            } */}


            {/* {
                JSON.stringify(inputFiles)
            } */}

        </Box>

    )
}